import type { PAGE_POSITIONS, PageType } from 'types';
import type { ProductListItemInternal } from 'types/capi/shared';

import { ExternalLink } from '~/components/Button';
import ProductCard from '~/components/ProductCard';
import gtm from '~/services/gtm.client';

type ProductCardCarouselProps = {
  allowNotifications: boolean;
  id: string;
  modulePosition: number;
  moduleType: string;
  onViewMoreProductsClick?: () => void;
  padImages: boolean;
  pagePosition?: PAGE_POSITIONS;
  pageType?: PageType;
  products: ProductListItemInternal[];
  title: string;
  trackingName?: string;
  viewMoreCopy?: string;
  viewMoreUrl?: string;
};

const ProductCardCarousel = ({
  id,
  modulePosition,
  moduleType,
  products,
  title,
  trackingName = title,
  viewMoreCopy,
  onViewMoreProductsClick,
  viewMoreUrl,
  padImages,
  pagePosition = 'PDP Carousel',
  pageType = 'pdp',
  allowNotifications
}: ProductCardCarouselProps) => {
  function sendGtmEvent() {
    gtm.sendUserInteractionEvent(`${trackingName} click`, 'Body');
  }

  const hasViewMoreLink = Boolean(viewMoreUrl && viewMoreCopy);

  return (
    <div className="flex flex-col gap-6" data-cy={id}>
      <h3 className="text-title-sm">{title}</h3>
      <div className="mx-auto grid max-w-screen-2xl grid-cols-2 gap-3 md:grid-cols-4">
        {products.map((product, index) => (
          <ProductCard.Internal
            key={product.id}
            product={product}
            padImage={padImages}
            cardSize="small"
            allowNotifications={allowNotifications}
            modulePosition={modulePosition}
            moduleType={moduleType}
            position={index + 1}
            onClick={sendGtmEvent}
            imageLoading={index < 10 ? 'eager' : 'lazy'}
            pageType={pageType}
            pagePosition={pagePosition}
          />
        ))}
      </div>
      {hasViewMoreLink && (
        <div className="flex justify-center">
          <div className="w-36">
            <ExternalLink
              variant="transparent-black-border"
              className="flex items-center justify-center"
              href={viewMoreUrl}
              onClick={onViewMoreProductsClick}
            >
              {viewMoreCopy}
            </ExternalLink>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCardCarousel;
